import React from 'react';
import { GridProps } from '@material-ui/core';
import clsx from 'clsx';
import useStyles from './styles';

export type StackProps = Pick<
    GridProps,
    'children' | 'className' | 'direction' | 'spacing' | 'alignItems' | 'justifyContent'
>;

const Stack: React.FC<StackProps> = ({
    alignItems = 'flex-start',
    children,
    className,
    direction = 'column',
    justifyContent = 'flex-start',
    spacing = 0,
}: StackProps) => {
    const classes = useStyles();

    return (
        <div
            className={clsx(
                classes.root,
                classes[`align-items-${alignItems}`],
                classes[`direction-${direction}`],
                classes[`justify-content-${justifyContent}`],
                { [classes[`direction-${direction}-spacing-${spacing}`]]: spacing && spacing > 0 },
                className,
            )}
        >
            {children}
        </div>
    );
};

export default Stack;
